import { environment } from '../../../environments/environment';
import { NotFoundPageComponent } from '../../components/not-found-page/not-found-page.component';
import { RegisterComponent } from '../../components/register/register.component';
import { InvitationNeededComponent } from '../../components/invitation-needed/invitation-needed.component';
import { WaitListComponent } from '../../components/wait-list/wait-list.component';
import { VerifyBtcpayInfoComponent } from './../../components/user-dashboard/portal/view/portal-payment/integrate/method-form/btcpay-special-method/verify-btcpay-info/verify-btcpay-info.component';
import { Routes } from '@angular/router';

export const full: Routes = [
  // {
  //   path: 'network',
  //   data: { title: 'learmo - Register' },
  //   loadChildren: () =>
  //     import(
  //       '../../components/affiliate-register/affiliate-register.module'
  //     ).then((m) => m.AffiliateRegisterModule),
  // },
  {
    path: 'auth',

    loadChildren: () =>
      import('../../components/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'verify',

    loadChildren: () =>
      import('../../components/user/verification.module').then(
        (m) => m.VerificationModule
      ),
  },
  {
    path: 'choose-plan',

    loadChildren: () =>
      import('../../components/choose-plan/choose-plan.module').then(
        (m) => m.ChoosePlanModule
      ),
  },
  {
    path: 'register',
    component: environment.disableRegister
      ? WaitListComponent
      : RegisterComponent,
  },
  {
    path: 'invitation-needed',
    component: InvitationNeededComponent,
  },
  {
    path: '404',
    component: NotFoundPageComponent,
  },
  {
    path: 'verification/btcpay-integration',
    component: VerifyBtcpayInfoComponent,
  },
];
